import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CopyPasteFilledSvg = function CopyPasteFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.462 2.249H12v2.353H6.462zM5.077 6.014v-3.06H3v14.59h6V8.13h6.461V2.955h-2.076v3.059zm5.308 3.53H21v12.705H10.385zm4.384 5.176H18v-1.412h-3.23zM18 18.484h-4.615v-1.411H18z",
    clipRule: "evenodd"
  }));
};
export var CopyPasteFilled = function CopyPasteFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CopyPasteFilledSvg
  }));
};